module.exports = __webpack_public_path__ + "img/alilogo.e8aa7fd3.png";